import { Input, Select } from "../../components/ui/Input";
import { LabelWithHint } from "../../components/ui/Tooltip";

const AUDIENCE_HELP =
	"Limit this campaign to shoppers who clicked a link carrying a parameter, such as an email linking to yourstore.com/?promo=moneyback. They see it for 3 days after the click; everyone else sees only your other campaigns. This hides the campaign, it does not lock its discount codes: someone who has a code can still use it at checkout.";

const DEFAULT_PARAM = "promo";

type AudienceFieldProps = {
	param: string | null;
	values: string[];
	onChange: (next: { audienceParam: string | null; audienceValues: string[] }) => void;
};

export const AudienceField = ({ param, values, onChange }: AudienceFieldProps) => {
	const linkOnly = param !== null;
	const value = values[0] ?? "";
	const suffix = `?${param ?? DEFAULT_PARAM}=${value || "…"}`;

	return (
		<div className="max-w-md space-y-1.5">
			<LabelWithHint label="Who sees this">{AUDIENCE_HELP}</LabelWithHint>
			<Select
				value={linkOnly ? "link" : "everyone"}
				onChange={(event) =>
					onChange(
						event.target.value === "link"
							? { audienceParam: DEFAULT_PARAM, audienceValues: [] }
							: { audienceParam: null, audienceValues: [] },
					)
				}
			>
				<option value="everyone">Every shopper</option>
				<option value="link">Only shoppers who arrive from a link</option>
			</Select>
			{linkOnly ? (
				<div className="space-y-2 pt-1">
					<div className="flex items-center gap-2">
						<Input
							aria-label="Link parameter"
							className="w-32"
							value={param}
							onChange={(event) =>
								onChange({ audienceParam: event.target.value.trim(), audienceValues: values })
							}
						/>
						<span className="text-ink-muted">=</span>
						<Input
							aria-label="Link value"
							placeholder="moneyback"
							value={value}
							onChange={(event) =>
								onChange({
									audienceParam: param,
									audienceValues: event.target.value.trim() ? [event.target.value.trim()] : [],
								})
							}
						/>
					</div>
					<p className="text-xs text-ink-muted">
						Add <code className="text-ink">{suffix}</code> to the links in your email. Use{" "}
						<code className="text-ink">&amp;</code> instead of <code className="text-ink">?</code>{" "}
						when the link already has a <code className="text-ink">?</code>.
					</p>
				</div>
			) : null}
		</div>
	);
};
